export const rootSelector = '#root';
export const rootElement: HTMLElement | null = document.querySelector(rootSelector);
